import React from 'react'
import styled from 'styled-components'
import { pricesCurrency } from 'utils'

import IcElectric from './images/ic-eletricity.component.svg'
import IcGas from './images/ic-gas.component.svg'

const EnergyDetailsV2 = (props) => {
  const {
    electricityConsumption,
    gasConsumption,
    prices,
    energyType,
    priceListTimeCycle,
    calculatedHiredPowerFactor,
    gasStage,
    border = true,
    className,
    ...restProps
  } = props

  const yearConsumption = Number(
    energyType === 'electricity' ? electricityConsumption : gasConsumption
  ).toFixed(0)
  const energy = pricesCurrency(
    energyType === 'electricity'
      ? prices.electricity.cheia
      : prices.gas.termo_energia
  )
  const cheia = pricesCurrency(
    energyType === 'electricity' ? prices.electricity.cheia : 0
  )
  const ponta = pricesCurrency(
    energyType === 'electricity' ? prices.electricity.ponta : 0
  )
  const vazio = pricesCurrency(
    energyType === 'electricity' ? prices.electricity.vazio : 0
  )

  const fixedTerm = pricesCurrency(
    energyType === 'electricity'
      ? prices.electricity.termo_fixo
      : prices.gas.termo_fixo
  )

  const _renderPotency = () => {
    return (
      energyType === 'electricity' && (
        <Detail>
          <p>Potência</p>
          <span>
            <h3>{Math.round(calculatedHiredPowerFactor * 1e2) / 1e2}</h3>
            <p>kVA</p>
          </span>
        </Detail>
      )
    )
  }

  const _renderTariff = () => {
    let timeCycleDeff =
      priceListTimeCycle === 's'
        ? 'Simples'
        : priceListTimeCycle === 'b'
        ? 'Bi-Horário'
        : 'Tri-Horário'

    return (
      energyType === 'electricity' && (
        <Detail>
          <p>Tarifário</p>
          <span>
            <h3>{timeCycleDeff}</h3>
          </span>
        </Detail>
      )
    )
  }

  const _renderStage = () => {
    return (
      energyType !== 'electricity' && (
        <Detail>
          <p>Escalão</p>
          <span>
            <h3>{gasStage}</h3>
          </span>
        </Detail>
      )
    )
  }

  return (
    <Wrapper className={className} {...restProps}>
      <TitleRow electricity={energyType === 'electricity'}>
        {energyType === 'electricity' ? <IcElectric /> : <IcGas />}
        <h1>
          {' '}
          {energyType === 'electricity' ? 'Eletricidade' : 'Gás Natural'}{' '}
        </h1>
      </TitleRow>

      <Details border={border}>
        <Detail>
          <p>Consumo</p>
          <span>
            <h3>{yearConsumption ? `${yearConsumption}` : '---'}</h3>
            <p>kWh/ano</p>
          </span>
        </Detail>

        <Detail>
          <p>
            {energyType === 'electricity' ? 'Termo Potência' : 'Termo Fixo'}
          </p>
          <span>
            <h3>{fixedTerm ? `${fixedTerm}` : '---'}</h3>
            <p>€/dia</p>
          </span>
        </Detail>

        {energyType !== 'electricity' ? (
          <Detail>
            <p>Energia</p>
            <span>
              <h3>{energy ? `${energy}` : '---'}</h3>
              <p>€/kWh</p>
            </span>
          </Detail>
        ) : null}

        {energyType === 'electricity' && priceListTimeCycle === 's' ? (
          <Detail>
            <p>Energia</p>
            <span>
              <h3>{cheia ? `${cheia}` : '---'}</h3>
              <p>€/kWh</p>
            </span>
          </Detail>
        ) : null}

        {energyType === 'electricity' && priceListTimeCycle !== 's' ? (
          <Detail>
            <p>Vazio</p>
            <span>
              <h3>{vazio ? `${vazio}` : '---'}</h3>
              <p>€/kWh</p>
            </span>
          </Detail>
        ) : null}

        {energyType === 'electricity' && priceListTimeCycle === 'b' ? (
          <Detail>
            <p>Fora do Vazio</p>
            <span>
              <h3>{cheia ? `${cheia}` : '---'}</h3>
              <p>€/kWh</p>
            </span>
          </Detail>
        ) : null}

        {energyType === 'electricity' &&
        priceListTimeCycle !== 'b' &&
        priceListTimeCycle !== 's' ? (
          <Detail>
            <p>Ponta</p>
            <span>
              <h3>{ponta ? `${ponta}` : '---'}</h3>
              <p>€/kWh</p>
            </span>
          </Detail>
        ) : null}

        {energyType === 'electricity' &&
        priceListTimeCycle !== 'b' &&
        priceListTimeCycle !== 's' ? (
          <Detail>
            <p>Cheias</p>
            <span>
              <h3>{cheia ? `${cheia}` : '---'}</h3>
              <p>€/kWh</p>
            </span>
          </Detail>
        ) : null}

        {_renderPotency()}
        {_renderTariff()}
        {_renderStage()}
      </Details>
    </Wrapper>
  )
}
export default EnergyDetailsV2

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  flex-grow: 1;
  width: 100%;

  @media screen and (min-width: 1000px) {
    width: unset;
    justify-content: flex-start;
  }
`

const TitleRow = styled.div`
  display: flex;
  height: 20px;
  padding: 10px 0px;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  align-self: stretch;

  > h1 {
    margin: 0;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Nunito;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 142.857% */
    color: ${({ electricity }) => (electricity ? '#FF8E2A' : '#10C1EE')};
    text-shadow: unset !important;
  }
`

const Details = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 2px;
  align-self: stretch;
  flex-grow: 1;
  width: 100%;

  ${({ border }) =>
    border &&
    ` 
    border-bottom: 1px solid #ECECEC;
    padding-bottom: 8px;
  `}

  @media screen and (min-width: 1000px) {
    flex-grow: unset;
    align-items: flex-start;
    width: unset;
    border-bottom: unset;
    padding-bottom: unset;
  }
`

const Detail = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  width: 100%;

  p,
  h3 {
    margin: 0;
    font-size: 14px;
    font-style: normal;
    line-height: 20px; /* 142.857% */
    font-weight: 400;
    text-transform: none;
  }

  p {
    color: #676767;
  }

  h3 {
    color: #1d1e22;
    font-weight: 700;
  }

  span {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    min-width: 100px;
  }

  @media screen and (min-width: 1000px) {
    align-self: stretch;
    width: unset;

    span {
      justify-content: flex-start;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/EnergyDetailsV2/index.js